import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  ApiError,
  LoadSearchPage,
  LoadSearchPageSuccess,
  SubmitSearch,
  SubmitSearchSuccess,
} from '../actions';
import { catchError, firstValueFrom, map, of, switchMap, withLatestFrom } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { GeneralState } from '../general.reducer';
import { CmsService } from '../../services/cms.service';
import { selectLanguage } from '../selectors';
import { LoadSearchPageSuccessData, PageBase, SearchResultPlugin } from '../../models';

@Injectable()
export class SearchEffects {
  private store = inject(Store<{ general: GeneralState }>);
  private actions$ = inject(Actions); // Alternative injection method
  private cms = inject(CmsService);

  onLoadSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadSearchPage),
      withLatestFrom(this.store.pipe(select(selectLanguage))),
      switchMap(([{ query }, language]) =>
        this.cms.getOrphan<PageBase & { form: LoadSearchPageSuccessData['form'] }>(language, 'search', query ? { query } : undefined).pipe(
          map((page) => { return LoadSearchPageSuccess({ page, form: page.form }); }),
          catchError((error) => of(ApiError({ error }))),
        ),
      ),
    ),
  );

  onSubmitSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SubmitSearch),
      withLatestFrom(this.store.pipe(select(selectLanguage))),
      switchMap(async ([action, language]) => {
        try {
          const page = await firstValueFrom(this.cms.search(language, { query: action.query.split(' ').filter(e => e != ' ').join(',') }));
          const noResults = page.content[0].plugin === 'search-no-result';

          return page.content[0].plugin === 'search-no-result' ? SubmitSearchSuccess({
            query: action.query,
            language,
            message: page.content[0].content.title
            // results: noResults ? [] : page.content
          }) : SubmitSearchSuccess({
            query: action.query,
            language,
            results: noResults ? [] : page.content as SearchResultPlugin[]
          });
        } catch (error) {
          return ApiError({ error });
        }
      })
    ));
}
